<template>
<div class="scroll-top-button" v-show="visible" @click="moveScrollTop">
  <i class="far fa-arrow-to-top"></i>
</div>
</template>

<script>
export default {
  name: 'WScrollTopButton',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    moveScrollTop() {
      this.$emit('move-scroll-top');
    },
  },
};
</script>

<style>
.scroll-top-button {
  position: absolute;
  z-index: 1;
  cursor: pointer;
  bottom: 20px;
  right: 23px;
  border: 1px solid rgba(172, 172, 172, 0.7);
  background-color: rgba(255, 255, 255, 0.7);
  width: 39px;
  height: 39px;
  color: rgba(113, 113, 113, 0.7);
  font-size: 13pt;
  border-radius: 3px;
  padding: 10px 12px 10px 12px;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1), 0 0 0 0.5px rgba(0, 0, 0, 0.04);
}
</style>



// WEBPACK FOOTER //
// src/components/button/ScrollTopButton/ScrollTopButton.vue